import axios from "axios";

import { apiSpaceUrl } from "utils/urls";

export const getNavigatorResources = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("navigator", spaceUuid), { params });
    return data;
};

export const getNavigatorFolders = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("navigatorFolder", spaceUuid), { params });
    return data;
};

export const getNavigatorTags = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("navigatorTag", spaceUuid), { params });
    data.sort((a, b) => {
        if (a.name < b.name) return -1;
        return 1;
    });
    return data;
};

export const postNavigatorTag = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("navigatorTag", spaceUuid), body);
    return data;
};

export const putNavigatorTag = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("navigatorTag", spaceUuid) + `/${body.id}`, body);
    return data;
};

export const deleteNavigatorBulkTag = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("navigatorTag", spaceUuid) + "/bulk-delete", { data: body });
    return data;
};

export const changeNavigatorTagOrder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("navigatorTag", spaceUuid) + "/order", body);
    return data;
};

export const addNavigatorFolderResources = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("navigatorFolder", spaceUuid) + "/resources", body);
    return data;
};

export const addNavigatorTagResources = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("navigatorTag", spaceUuid) + "/resources", body);
    return data;
};

export const postNavigatorFolder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("navigatorFolder", spaceUuid), body);
    return data;
};

export const putNavigatorFolder = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("navigatorFolder", spaceUuid) + `/${body.id}`, body);
    return data;
};

export const deleteNavigatorBulkFolder = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("navigatorFolder", spaceUuid) + "/bulk-delete", { data: body });
    return data;
};

export const changeNavigatorFolderOrder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("navigatorFolder", spaceUuid) + "/order", body);
    return data;
};

export const mergeNavigatorFolder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("navigatorFolder", spaceUuid) + "/merge", body);
    return data;
};
